module.exports = __webpack_public_path__ + "img/2-8.fb14fd76.svg";